import { Component, Inject, OnDestroy } from '@angular/core'
import { GoogleAnalyticsService } from '../../../core/monitoring/google-analytics.service'
import { selectBulkOperationsState } from '../state/main-view.selectors'
import { Subscription } from 'rxjs'
import { Store } from '@ngrx/store'
import { MainViewActions } from '../state/action-types'

@Component({
    selector: 'ca-bulk-operation-announcements',
    templateUrl: './bulk-operation-announcements.html'
})
export class BulkOperationAnnouncementsComponent implements OnDestroy {

    contractBulkOperationsLoading: boolean
    bulkOperations: any[]
    showBulkOperations: boolean
    existContractBulkOperation: boolean

    #selectBulkOperationsState: Subscription

    constructor(@Inject(Store) private store: Store,
                @Inject(GoogleAnalyticsService) private googleAnalyticsService: GoogleAnalyticsService) {

        this.#selectBulkOperationsState = this.store.select(selectBulkOperationsState).subscribe(state => {
            this.contractBulkOperationsLoading = state.contractBulkOperationsLoading
            this.bulkOperations = state.bulkOperations
            this.showBulkOperations = state.showBulkOperations
            this.existContractBulkOperation = state.existContractBulkOperation
        })
    }


    ngOnDestroy(): void {
        this.#selectBulkOperationsState?.unsubscribe()
        this.store.dispatch(MainViewActions.toggleShowBulkOperationsOff())
    }

    toggleContractBulkOperations(): void {
        this.store.dispatch(MainViewActions.toggleShowBulkOperations())
        if (this.showBulkOperations === true) {
            this.googleAnalyticsService.logEvent('header', 'bulk_operations', 'open')
        }
    }

    hideContractBulkOperations(): void {
        if (this.showBulkOperations === true) {
            this.store.dispatch(MainViewActions.toggleShowBulkOperationsOff())
        }
    }

    logBulkOperationsNavigation(): void {
        this.googleAnalyticsService.logEvent('header', 'bulk_operations', 'show_all')
    }
}